import type { FC } from 'react';
import { resolveVehicleSVG } from '../../use-cases/manage/details/utils/vehicleType';
import { Colors } from '../colors';

interface VehicleTypeIconProps {
  type: string;
}

const VehicleTypeIcon: FC<VehicleTypeIconProps> = ({ type }) => {
  const TypeIcon = resolveVehicleSVG(type);

  if (TypeIcon) {
    return (
      <TypeIcon
        color={Colors.UI2}
        style={{
          flex: 'none',
          width: '3rem',
          height: '3rem',
        }}
      />
    );
  }

  return null;
};

export default VehicleTypeIcon;
